import { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowUpRight, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import './closing.css';

const QUESTIONS = [
  ['How do I get my personal timetable?', 'Choose your program, year, semester, and group. Your dashboard brings together the classes and room details for your academic day.'],
  ['Do I need to download an app?', 'Open UniSchedule in your browser on a phone, tablet, or computer. Supported browsers also let you add it to your home screen.'],
  ['What can I ask Owlet?', 'Ask about classes, room locations, campus transport, and academic dates. Your profile gives Owlet context for timetable questions.'],
  ['What if my program is not listed?', 'Send us your program and semester details through the contact page. The team can help check availability or look into a missing timetable.'],
] as const;

export default function FaqSection() {
  const [active, setActive] = useState<number | null>(0);
  const reducedMotion = useReducedMotion();
  return (
    <section id="questions" className="mk-faq mk-section" aria-labelledby="mk-faq-heading">
      <div className="mk-container mk-faq-layout">
        <motion.div className="mk-faq-intro" initial={reducedMotion ? false : { opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: .7 }}>
          <p className="mk-eyebrow">05 / GOOD TO KNOW</p>
          <h2 id="mk-faq-heading" className="mk-heading">Good questions.<br /><span>Clear answers.</span></h2>
          <p className="mk-copy">A few things before your<br />next chapter begins.</p>
          <Link to="/contact" className="mk-text-link">Ask us something else <ArrowUpRight size={17} /></Link>
        </motion.div>
        <div className="mk-faq-items">
          {QUESTIONS.map(([question, answer], index) => (
            <div key={question} className="mk-faq-item" data-open={active === index}>
              <h3><button type="button" id={`mk-question-${index}`} aria-expanded={active === index} aria-controls={`mk-answer-${index}`} onClick={() => setActive(active === index ? null : index)}>
                <span className="mk-faq-number">0{index + 1}</span><span>{question}</span><motion.span className="mk-faq-toggle" animate={{ rotate: active === index ? 45 : 0 }} transition={{ duration: reducedMotion ? 0 : .25 }}><Plus size={20} /></motion.span>
              </button></h3>
              <div id={`mk-answer-${index}`} role="region" aria-labelledby={`mk-question-${index}`}>
                <AnimatePresence initial={false}>
                  {active === index && <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: reducedMotion ? 0 : .28, ease: [.22, 1, .36, 1] }} className="mk-faq-answer"><p>{answer}</p></motion.div>}
                </AnimatePresence>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
